import { GET_ENC, POST_ENC } from "./common/EncryptedHttp";
import { BASE_URL } from "./common/const";

export const GetMedicineRouteOfAdministrationDetail = (params: any) =>
    GET_ENC(`${BASE_URL}/api/MedicineRouteOfAdministration/GetDetail?` + params, null);

export const GetMedicineRouteOfAdministrationList = (params: any) =>
    GET_ENC(`${BASE_URL}/api/MedicineRouteOfAdministration/GetList?` + params, null);

export const CreateMedicineRouteOfAdministration = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MedicineRouteOfAdministration/Create`, data);

export const UpdateMedicineRouteOfAdministration = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MedicineRouteOfAdministration/Update`, data);

export const DeleteMedicineRouteOfAdministration = (data: any) =>
    POST_ENC(`${BASE_URL}/api/MedicineRouteOfAdministration/Delete`, data);